"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
// Hook
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
exports.default = (name, props) => {
    const LOG_LEVEL = window["LOG_LEVEL"] || "";
    // Get a mutable ref object where we can store props ...
    // ... for comparison next time this hook runs.
    const previousProps = (0, react_1.useRef)();
    const initial = (0, react_1.useRef)(true);
    if (LOG_LEVEL.toUpperCase() !== "DEBUG")
        return;
    if (previousProps.current) {
        // Get all keys from previous and current props
        const allKeys = Object.keys(Object.assign(Object.assign({}, previousProps.current), props));
        // Use this object to keep track of changed props
        const changesObj = {};
        // Iterate through keys
        allKeys.forEach((key) => {
            // If previous is different from current
            if (previousProps.current[key] !== props[key]) {
                // Add to changesObj
                changesObj[key] = {
                    from: previousProps.current[key],
                    to: props[key],
                };
            }
        });
        if (Object.keys(changesObj).length) {
            console.debug("[why-did-you-update]: [re-render]", name, "changes", changesObj);
        }
        else {
            console.debug("[why-did-you-update]: [re-render] - [no Changes]", name, props);
        }
    }
    else if (initial) {
        console.debug("[why-did-you-update]: [new-render]", name, props);
    }
    else {
        console.debug("[why-did-you-update]: [new-render-not-initial]", name, props);
    }
    initial.current = false;
    previousProps.current = props;
};
